import { render } from "./SuccessScreen.vue?vue&type=template&id=35ed7718&scoped=true&ts=true"
import script from "./SuccessScreen.vue?vue&type=script&lang=ts"
export * from "./SuccessScreen.vue?vue&type=script&lang=ts"

import "./SuccessScreen.vue?vue&type=style&index=0&id=35ed7718&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ed7718"]])

export default __exports__